(function (root) {
  function bindExclusive(scope) {
    var rootEl = scope || root.document;
    if (!rootEl || !rootEl.querySelectorAll) return;
    rootEl.querySelectorAll("[data-fh-exclusive-accordion]").forEach(function (list) {
      if (list.getAttribute("data-fh-exclusive-bound") === "true") return;
      list.setAttribute("data-fh-exclusive-bound", "true");
      list.addEventListener(
        "toggle",
        function (event) {
          var item = event.target;
          if (!item || item.tagName !== "DETAILS" || !item.open) return;
          list.querySelectorAll("details[open]").forEach(function (other) {
            if (other !== item) other.open = false;
          });
        },
        true
      );
    });
  }

  root.fhBindExclusiveAccordion = bindExclusive;

  if (root.document) {
    if (root.document.readyState === "loading") {
      root.document.addEventListener("DOMContentLoaded", function () {
        bindExclusive(root.document);
      });
    } else {
      bindExclusive(root.document);
    }
    root.document.addEventListener("shopify:section:load", function (event) {
      bindExclusive(event.target);
    });
  }
})(typeof window !== "undefined" ? window : globalThis);
